import React, {useState, useEffect} from "react"
import Productlist from "./Productlist"; 
export default function Productapi() {
    const [article,setArticle] = useState([]);

    const getData = () => {
        const requestOptions = {
            method: 'GET',
            headers: { 
              'Content-Type':  'application/x-www-form-urlencoded;charset=UTF-8',
            },
            // body: formBody
          }
        let url = "https://fakestoreapi.com/products";
        fetch(url,requestOptions).then(response => response.json()).then(response => {
               // console.log("DATA IS", response);
                setArticle(response);
        }).catch(error => {
            console.log("Error is",error)
        })
    }


    useEffect(() => {
        getData();
    },[])

  return (
<>
            <div className="row">
                {article.map((data,index)=> {
                   // console.log("ALL DATA",data)
                    return(
                        <>
                        <div className="col-md-3">
                        <Productlist key={index} articles={data} cnewscat="" />
                        </div>
                        </>
                    )
                })}

            </div> 
            </>
  )
}
